import React from 'react';
import { Button, Text } from '@chatsdet/ui';
import { CaretDown, CaretRight, Plus } from '@phosphor-icons/react';
import type { ApplicationContextItem, ApplicationContextSection } from '../types';
import { SECTION_LABELS } from '../types';
import { ContextItemCard } from './ContextItemCard';

type Props = {
  section: ApplicationContextSection;
  items: ApplicationContextItem[];
  onEditItem: (item: ApplicationContextItem) => void;
  onDeleteItem: (item: ApplicationContextItem) => void;
  onViewHistory: (item: ApplicationContextItem) => void;
  onAddItem: (section: ApplicationContextSection) => void;
};

export function ContextSectionCard({
  section,
  items,
  onEditItem,
  onDeleteItem,
  onViewHistory,
  onAddItem,
}: Props) {
  const [isExpanded, setIsExpanded] = React.useState(true);

  return (
    <div className="border-b border-border last:border-b-0">
      <button
        onClick={() => setIsExpanded((v) => !v)}
        className="flex w-full items-center gap-2 py-3 text-left hover:bg-muted/30 transition-colors px-1"
      >
        {isExpanded ? (
          <CaretDown size={12} className="text-muted-foreground shrink-0" />
        ) : (
          <CaretRight size={12} className="text-muted-foreground shrink-0" />
        )}
        <Text size="sm" weight="semibold" className="text-foreground">
          {SECTION_LABELS[section]}
        </Text>
        <Text size="xs" className="text-muted-foreground">
          {items.length}
        </Text>
      </button>

      {isExpanded && (
        <div className="pb-3 pl-5">
          {items.length === 0 ? (
            <Text size="sm" className="text-muted-foreground italic py-2">
              No items yet
            </Text>
          ) : (
            <div className="divide-y divide-border/50">
              {items.map((item) => (
                <ContextItemCard
                  key={item.id}
                  item={item}
                  onEdit={onEditItem}
                  onDelete={onDeleteItem}
                  onViewHistory={onViewHistory}
                />
              ))}
            </div>
          )}
          <div className="mt-1">
            <Button variant="ghost" size="sm" onPress={() => onAddItem(section)}>
              <Plus size={12} />
              <Text size="xs">Add item</Text>
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
